const AnimationDuration = {
    SLOW: 1350,
    NORMAL: 650,
    FAST: 450,
    INSTANT: 0
}

export default AnimationDuration;